import axiosSetup from "../utils/axiosSetup";

export const handleLogoutApi = async () => {
  try {
    const response = await axiosSetup.put("/logout");
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message || error.message || "Logout failed";
    throw new Error(message);
  }
};
